// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3NUdD","detailsBorder":"styles_detailsBorder__uxsoH"};